import React, { useContext, useState } from 'react';
import { AuthContext } from 'context/auth';
import {
  Box,
  Center,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from '@chakra-ui/react';
import { config } from 'util/constants';
import SubmitterForm from '../components/SubmitterForm';
import GeneralOverview from '../components/GeneralOverview';
import GoogleButton from 'react-google-button';
import ManageSubmittedMCFS from 'components/ManageSubmittedMCFS';

export default function HomePage() {
  const { user } = useContext(AuthContext);
  const [tabIndex, setTabIndex] = useState(user.admin || user.mentor ? 2 : 0);

  const handleTabsChange = index => {
    setTabIndex(index);
  };

  // TODO: Add notifications? for updates/new parts added

  if (user === 'NoUser') {
    return (
      <Center>
        <a
          style={{ marginTop: '100px' }}
          href={`${config.API_URL}/auth/google`}
        >
          <GoogleButton />
        </a>
      </Center>
    );
  }

  return (
    <>
      <Box>
        <Tabs
          index={tabIndex}
          onChange={handleTabsChange}
          isFitted
          size="lg"
          colorScheme="green"
        >
          <TabList
            background={'white'}
            top={'5rem'}
            zIndex={998}
            position={'sticky'}
          >
            <Tab borderBottom={'4px solid'} mb={'-4px'}>
              My Submitted Part MCFs
            </Tab>
            <Tab borderBottom={'4px solid'} mb={'-4px'}>
              Submit Part MCF
            </Tab>
            <Tab borderBottom={'4px solid'} mb={'-4px'}>
              General Overview {(user.admin || user.mentor) && '/ Review'}
            </Tab>
          </TabList>
          <TabPanels>
            <TabPanel>
              <ManageSubmittedMCFS />
            </TabPanel>
            <TabPanel>
              <SubmitterForm />
            </TabPanel>
            <TabPanel>
              <GeneralOverview />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Box>
    </>
  );
}
